import _styled from '@emotion/styled/base';
import { spacing } from '@hubble/tokens/web';

const Content = _styled('div', {
  target: "ehd8dwa0"
})("display:block;padding-inline:", spacing[24], ";flex-grow:1;overflow:auto;position:relative;");

export { Content };
